import React from 'react'
import { NumberInputProps } from 'react-admin'
import { multipleOf } from 'services/utils/validation'
import { truncate } from 'services/utils/prices'
import KNumberInput from './KNumberInput'

type Props = NumberInputProps & {
  source: string
}

const HalfStepNumberInput: React.FC<Props> = ({ validate = [], ...rest }) => (
  <KNumberInput
    {...rest}
    step={0.5}
    validate={[validate, multipleOf(0.5)].flat()}
    parse={(n: number) => truncate(n, 1)}
  />
)

export default HalfStepNumberInput
